import { use as i18nextUse } from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEN from '@social-garden/locales/en/common.json';
import commonDE from '@social-garden/locales/de/common.json';
import commonAR from '@social-garden/locales/ar/common.json';
import managerEN from '@social-garden/locales/en/manager.json';
import managerDE from '@social-garden/locales/de/manager.json';
import managerAR from '@social-garden/locales/ar/manager.json';

export const DEFAULT_NS = 'common';

export const RESOURCES = {
  en: {
    manager: managerEN,
    common: commonEN,
  },
  de: {
    manager: managerDE,
    common: commonDE,
  },
  ar: {
    manager: managerAR,
    common: commonAR,
  },
} as const;

export function initI18n() {
  return i18nextUse(initReactI18next).init({
    resources: RESOURCES,
    ns: ['common', 'manager'],
    defaultNS: DEFAULT_NS,
    lng: navigator.language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    returnNull: false,
    returnEmptyString: false,
  });
}
